import { render, staticRenderFns } from "./promote.vue?vue&type=template&id=656e671e&scoped=true&"
import script from "./promote.vue?vue&type=script&lang=js&"
export * from "./promote.vue?vue&type=script&lang=js&"
import style0 from "./promote.vue?vue&type=style&index=0&id=656e671e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656e671e",
  null
  
)

export default component.exports